module.exports = __webpack_public_path__ + "img/prof.94ccb872.svg";